module.exports = __webpack_public_path__ + "static/media/image_20.0a37fbd5.png";